<template>
  <div class="main">
    <div class="pure-g">
      <div class="pure-u-1-1">   
        <h1>Rest tests generator</h1>
        <p>Generate <a href="https://www.getpostman.com/">Postman</a> or <a href="https://github.com/cucumber/cucumber/wiki/Gherkin">Gherkin based BDD</a> tests online from <a href="https://swagger.io/">Swagger</a> v2 specification.</p>
      </div>
   
    <div class="pure-u-1-1">
      
      <div class=" pure-form">
         <fieldset class="pure-group">
           <h2>Start</h2>
         <textarea placeholder="Enter url or contents of your Swagger v2 specification" v-model="specs" class="pure-input-1"  rows=10>></textarea>
      
       </fieldset>
        <button type="submit" v-on:click="generate" class="pure-button pure-input-1-4 pure-button-primary" :disabled="specs==null" title="Click to generate tests">Generate</button>
           <button type="submit" v-on:click="clear" class="pure-button pure-input-1-4 button-warning" :disabled="results==null || results.length == 0" title="Click to clear tests">Clear</button>
 
      </div>
    </div>
     <div class="pure-u-1-1 errors" v-if="errors">
       <p>{{errors}}</p>
     </div>
    <div class="pure-u-1-1" v-if="results && results.files">
      <div class="pure-g"> 
        <div class="pure-u-1-1">
          <h2>Results </h2>
      
        
                <button type="submit" v-on:click="showPostman" class="pure-button pure-input-1-4 button-success" title="Click to show Postman tests">Postman</button>
  
                <button type="submit" v-on:click="showGherkin" class="pure-button pure-input-1-4 button-success" title="Click to Gherkin tests">Gherkin</button>
  
        </div>
        
        <div v-for="item in results.files" :key="item.name" class="pure-u-1-1">
          <div class="pure-g">
            <div class="pure-u-1-1">
              <h3 class='generated-content-name'>{{item.name || "File contents"}} <button class="pure-button pure-input-1-4 button-warning copy-btn"       v-clipboard:copy="item.contents">Copy</button></h3>
            </div>
          </div>
              <div class="pure-g center generated-code">
            <div class="pure-u-1-1 pure-form ">
               <pre v-html="getCode(item)"></pre>   
           
            </div>
          </div>
        </div>
      </div>
    </div> 
    </div>
</div>
</template>

<script>
require("highlight.js/styles/github.css");
var hljs = require("highlight.js/lib/highlight.js");
hljs.registerLanguage("gherkin", require("highlight.js/lib/languages/gherkin"));
hljs.registerLanguage(
  "javascript",
  require("highlight.js/lib/languages/javascript")
);

var generator = require("resttestsgenerator");

var clipboard = require("clipboard");
export default {
  name: "MainPage",

  methods: {
    getCode: function(item) {
      console.log(item.contents);
      var tmp = hljs.highlightAuto(item.contents, ["gherkin", "javascript"])
        .value;

      return tmp;
    },
    clear: function() {
      this.generationResults = null;
      this.results = [];
      this.errors = null;
    },
    generate: function() {
      var self = this;
      var swaggerApi = this.specs;

      generator
        .generateFromSwagger(swaggerApi)
        .then(function(r) {
          self.generationResults = r;
          self.errors = null;
          self.showPostman();
        })
        .catch(function(e) {
          self.errors =
            "Error occured while trying to generate tests. Please check your swagger specification or provided url. Actual error was: " +
            e;
        });
    },
    showPostman: function() {
      this.results = this.generationResults.results[1];
      this.format = "javascript";
    },
    copy: function(item) {},
    showGherkin: function() {
      this.results = this.generationResults.results[0];
      this.format = "gherkin";
    }
  },
  data() {
    return {
      specs: null,
      format: null,
      errors: null,
      generationResults: null,
      results: [],
      methods: ["get", "post", "delete", "put"],
      statusCodes: [],
      msg: "Welcome to Your Vue.js App"
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.errors {
  margin-top: 5px;
  background-color: rgba(49, 30, 34, 4);
  color: white;
  font-weight: 700;
}
.copy-btn {
  float: right;
  font-size: 12px;
}
.generated-content {
  max-height: 300px;
  text-align: left;
  white-space: pre-wrap;
  word-wrap: break-word;
}
pre {
  text-align: left;
  max-height: 300px;
}
.center {
  margin: 20px;
  display: -flexbox;
  align-content: flex-start;
}
</style>



// WEBPACK FOOTER //
// src/components/MainPage.vue